export default __webpack_public_path__ + "static/media/hornbach-stock.29bc06d2.svg";